import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug) || categories[0];
  const categoryArticles = articles.filter((a) => a.category === currentCategory.slug);

  const catColors: Record<string, string> = {
    'liuman-video-dingyi': 'primary',
    'shibie-exing-shipin': 'accent',
    'fangfan-cuoshi': 'secondary',
    'jubao-weiquan': 'primary',
  };
  const colorKey = catColors[currentCategory.slug] || 'primary';

  const bgLight = `bg-${colorKey}-100/80`;
  const textColor = `text-${colorKey}-600`;
  const activeBg = `bg-${colorKey}-100`;
  const activeText = `text-${colorKey}-700`;

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title={`${currentCategory.name} - 网络安全守护`}
        description={currentCategory.description}
        keywords={`${currentCategory.name},流氓视频,网络安全,恶意视频`}
        canonicalUrl={`https://wangluoanquan.cn/category/${currentCategory.slug}`}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-16">
          <div className="bg-background-100 border-b border-background-200/60">
            <div className="max-w-6xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: currentCategory.name },
                ]}
              />
            </div>
          </div>

          <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-10">
                <div className={`w-14 h-14 flex items-center justify-center rounded-lg ${bgLight}`}>
                  <i className={`${currentCategory.icon} text-2xl ${textColor}`}></i>
                </div>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                    {currentCategory.name}
                  </h1>
                  <p className="text-sm text-foreground-500">{currentCategory.description}</p>
                </div>
              </div>

              {/* Category Tabs */}
              <div className="flex flex-wrap gap-2 mb-10">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      cat.slug === currentCategory.slug
                        ? `${activeBg} ${activeText} font-medium`
                        : 'bg-background-50 border border-background-200/60 text-foreground-500 hover:border-primary-200/60 hover:text-foreground-700'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              {categoryArticles.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  {categoryArticles.map((article) => (
                    <ArticleCard key={article.slug} article={article} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                    <i className="ri-file-list-3-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">该分类下暂无文章，敬请期待</p>
                </div>
              )}
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}